<template>
  <div class="car">
    <div class="boxCenter">
      <div class="carCenterBox">
        <div class="titleBox">购物车</div>
        <div class="listTh">
          <el-row>
            <el-col :span="3"><span style="padding-left: 20px;"></span><el-checkbox v-model="selectAll" @change="selectAllChange">全选</el-checkbox></el-col>
            <el-col :span="7" class="centerF"></span>商品信息</el-col>
            <el-col :span="3" class="centerF"></el-col>
            <el-col :span="3" class="centerF">价格</el-col>
            <el-col :span="3" class="centerF">数量</el-col>
            <el-col :span="3" class="centerF">金额</el-col>
            <el-col :span="2" class="centerF">操作</el-col>
          </el-row>
        </div>
        <div class="listTd" v-for="(item,index) in carList" :key="index">
          <el-row class="carItem">
            <el-col :span="1"><span style="padding-left: 20px;"><el-checkbox v-model="item.selected" @change="countAllPrice"></el-checkbox></span></el-col>
            <el-col :span="9">
              <div class="imgBox"><router-link :to="'/productDetails/'+item.goodsId"><img :src="item.pic"></router-link></div>
              <div class="infoBox">{{item.name}}</div>
            </el-col>
            <el-col :span="3" class="centerF"><span>{{item.property}}</span></el-col>
            <el-col :span="3" class="centerF"><span>￥{{item.memberPrice.toFixed(2)}}</span></el-col>
            <el-col :span="3" class="centerF">
              <el-input-number v-model="item.num" @change="numberChange(item,index)" size="small"></el-input-number>
            </el-col>
            <el-col :span="3" class="centerF"><span>￥{{(item.memberPrice * item.num).toFixed(2)}}</span></el-col>
            <el-col :span="2" class="centerF" style="line-height: 93px;"><el-button size="mini" type="danger" @click="deleteItem(item,index)">删除</el-button></el-col>
          </el-row>
        </div>

        <div class="comfirmBox">
          <span class="num">已选商品{{total}}件</span>
          <span>合计（不含运费）:</span>
          <span class="total">￥{{totalPrice.toFixed(2)}}</span>
          <span class="btn" @click="goToDeal">结算</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    data(){
      return {
        userId:9,
        selectAll:false,
        num:1,
        carList:[],
        totalPrice:0,
        total:0
      }
    },
    computed: {
      userData() {
        return this.$store.state.userData
      }
    },
    watch: {
      userData: {
        handler(newName, oldName){
          if (newName) {
            this.loadData()
          }
        },
        immediate: true
      }
    },
    mounted(){
      //this.loadData()
    },
    methods:{
      loadData(){
        this.$https.get('/api/cart/memberId/'+this.userData.id).then((response)=>{
          response.data.forEach(item => {
            item.selected = false
          })
          this.carList = response.data
        }).catch((error) => {

        });
      },
      //选择全部
      selectAllChange(val){
        this.carList.forEach(item => {
          item.selected = val
        })
        this.countAllPrice()
      },
      numberChange(item,index){
        if (item.num == 0) {
          this.deleteItem(item,index)
        }else{
          this.updateCarItem(item)
          this.countAllPrice()
        }
      },
      updateCarItem(item){
        this.$https.post('/api/cart/updateCart',item).then(res => {});
      },
      deleteItem(item,index){
        this.$confirm('确定取从购物车删除？', '提示', {
          title: '',
          message: '确认删除吗？',
          showCancelButton: true
        }).then(action => {
          this.$https.post('/api/cart/id/'+item.id,{}).then(res => {
            if(res.code == 0){
              this.$message.success("操作成功")
              this.carList.splice(index,1)
            }else{
              this.$toast(res.message)
            }
          });
        }).catch(err =>{
          item.num = 1
          this.countAllPrice()
        });
      },
      //计算总价
      countAllPrice(){
        let _totalPrice = 0
        let _total = 0

        this.carList.forEach(item => {
          if(item.selected){
            _total += item.num
            _totalPrice += (item.num * item.memberPrice)
          }
        })

        this.totalPrice = _totalPrice
        this.total = _total
      },
      //去结算
      goToDeal(){
        let proArr = []
        this.carList.forEach(item => {
          if(item.selected){
            proArr.push(item)
          }
        })
        if(proArr.length == 0){
          this.$message.warning("请选择商品")
          return
        }
        localStorage.setItem('proArr' , JSON.stringify(proArr))
        this.$router.push({
          path: `/proOrderConfirm`,
        })
      }
    }
  }
</script>

<style scoped>
  .car{
    background:#fafafa;
    padding: 1px 0;
  }
  .carCenterBox{
    width: 1200px;
    background: #ffffff;
    margin: 30px auto;
  }
  .titleBox{
    width: 1100px;
    height: 70px;
    line-height: 70px;
    padding-top: 15px;
    font-size: 24px;
    color: #333333;
    margin: 0 auto;
    border-bottom: 1px solid #E5E5E5;
  }
  .listTh{
    width: 1077px;
    height: 32px;
    line-height: 32px;
    border: 1px solid #5680F9;
    border-top: 3px solid #5680F9;
    margin: 20px auto 0;
    color: #363636;
    font-size: 14px;
  }
  .listTd{
    width: 1079px;
    background: #FBFBFB;
    border: 1px solid #E5E5E5;
    margin: 10px auto;
    font-size: 14px;
    color: #919191;
  }
  .listTd span{
    line-height: 93px;
  }
  .centerF{
    text-align: center;
    min-height: 1px;
  }
  .carItem{
    margin: 12px 0;
  }
  .imgBox{
    float: left;
    width: 118px;
    height: 91px;
    background: #FFFFFF;
    border: 1px solid #E5E5E5;
  }
  .imgBox img{
    width: 100%;
    height: 100%;
  }
  .infoBox{
    padding-left: 130px;
    font-size: 12px;
    color: #666666;
    line-height: 16px;
  }
  /deep/ .el-input-number--small{
    /*width: 90px;*/
    margin-top: 30px;
  }
  .comfirmBox{
    height: 49px;
    line-height: 49px;
    background: #FFFFFF;
    border: 1px solid #E5E5E5;
    padding: 0 106px;
    text-align: right;
    font-size: 14px;
    color: #666666;
  }
  .comfirmBox .btn{
    display: inline-block;
    width: 85px;
    line-height: 27px;
    text-align: center;
    height: 27px;
    background: #FFCD30;
    border-radius: 4px;
    cursor: pointer;
    color: #ffffff;
  }
  .comfirmBox .total{
    color: #E50001;
    margin-right: 44px;
  }
  .comfirmBox .num{
    margin-right: 111px;
  }
</style>



// WEBPACK FOOTER //
// src/components/car.vue